import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {},                 // 用户信息
    uid: '',                  // 用户id
    token: '',               // 用户token
    online: true,             // 判断再线与否
    devInfo: {},              // 设备信息
    OFFSET: '',                 // 加密偏移量
    inviteCode:'',              //活动邀请码
    newMessage: 0,                // 未读消息数量
    messages: [],                 // 消息
    neteasecloud: false,      // 在云游戏app
    
		drawGameId: 62,             //云游戏抽奖
		drawLoginToken:null,        //云游戏抽奖登录token
		drawUserid:'',              //云游戏抽奖userid
    drawInviteCode: '',          //云游戏抽奖邀请码
    
    isCanDrawFlag: true        // 正在抽奖时不可切换tab
  },
  getters,
  mutations,
  // 异步的数据操作
  actions,
  plugins: []
})
export default store
